import { render } from "./HeaderTitle.vue?vue&type=template&id=10c9d074&scoped=true&ts=true"
import script from "./HeaderTitle.vue?vue&type=script&lang=ts"
export * from "./HeaderTitle.vue?vue&type=script&lang=ts"

import "./HeaderTitle.vue?vue&type=style&index=0&id=10c9d074&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c9d074"]])

export default __exports__